import React from "react";
import { Play, Eye, FileText } from "lucide-react";

const MediaGallery = ({ 
  videos, 
  collateral, 
  activeTab, 
  showVideos, 
  showCollateral, 
  onView 
}) => {
  return (
    <div className="space-y-12">
      {/* Videos Section */}
      {(activeTab === "all" || activeTab === "videos") &&
        showVideos &&
        videos.length > 0 && (
          <section className="space-y-6">
            <div className="flex items-center gap-3 px-1">
              <div className="w-1 h-6 bg-indigo-600 rounded-full" />
              <h2 className="text-lg font-black text-slate-800 uppercase tracking-tight">
                Videos
              </h2>
              <div className="h-px bg-slate-100 flex-grow ml-2" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {videos.map((video) => (
                <div
                  key={video.id}
                  className="group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
                >
                  {/* Video Thumbnail Area */}
                  <div 
                    onClick={() => onView(video)}
                    className="relative aspect-video bg-slate-50 flex items-center justify-center overflow-hidden cursor-pointer"
                  >
                    <img
                      src={video.thumbnail || "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=1000"}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                      <div className="w-12 h-12 rounded-full bg-white/95 shadow-xl flex items-center justify-center text-indigo-600 scale-90 group-hover:scale-100 transition-transform duration-300">
                        <Play size={24} fill="currentColor" />
                      </div>
                    </div>
                  </div>
                  {/* Card Content */}
                  <div className="px-6 py-5 flex items-center justify-between border-t border-slate-50">
                    <div className="min-w-0">
                      <h3 className="text-sm font-bold text-slate-900 truncate">
                        {video.title}
                      </h3>
                      <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest mt-0.5">
                        Click to play
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

      {/* Collateral Segment */}
      {(activeTab === "all" || activeTab === "collateral") &&
        showCollateral &&
        collateral.length > 0 && (
          <section className="space-y-6">
            <div className="flex items-center gap-3 px-1">
              <div className="w-1 h-6 bg-indigo-600 rounded-full" />
              <h2 className="text-lg font-black text-slate-800 uppercase tracking-tight">
                Collateral
              </h2>
              <div className="h-px bg-slate-100 flex-grow ml-2" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {collateral.map((item) => (
                <div
                  key={item.id}
                  className="group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
                >
                  <div 
                    onClick={() => onView(item)}
                    className="relative aspect-video bg-slate-50 flex items-center justify-center overflow-hidden cursor-pointer"
                  >
                    {item.thumbnail ? (
                      <img
                        src={item.thumbnail}
                        alt={item.title}
                        className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                      />
                    ) : (
                      <div className="p-10 rounded-2xl bg-white shadow-sm border border-slate-100">
                        <FileText size={40} className="text-indigo-600" />
                      </div>
                    )}
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                        <div className="w-12 h-12 rounded-full bg-white/95 shadow-xl flex items-center justify-center text-indigo-600 opacity-0 group-hover:opacity-100 scale-90 group-hover:scale-100 transition-all duration-300">
                            <Eye size={24} />
                        </div>
                    </div>
                  </div>
                  <div className="px-6 py-5 flex items-center justify-between border-t border-slate-50">
                    <div className="min-w-0">
                      <h3 className="text-sm font-bold text-slate-900 truncate">
                        {item.title}
                      </h3>
                      <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest mt-0.5">
                        {item.file_type?.split("/")[1] || "Document"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
    </div>
  );
};

export default MediaGallery;
